import { useCallback, useEffect, useState } from 'react';
import { restApi } from '../../../../services/api';
import { OrderTransportCondition } from '../../order.types';

export type OrderDefinitions = {
  shippingCompanyIntegration: boolean;
  orderTransportCondition: OrderTransportCondition;
  orderClassificationsIntegration: boolean;
  hasOrderOperationsIntegration: boolean;
  hasOrderChargeTypeIntegration: boolean;
  showLocals: boolean;
  showEmitInvoice: boolean;
  batchItemsIntegration: boolean;
};

const orderDefinitionsDefault: OrderDefinitions = {
  shippingCompanyIntegration: false,
  orderTransportCondition: OrderTransportCondition.NONE,
  orderClassificationsIntegration: false,
  showLocals: false,
  showEmitInvoice: false,
  batchItemsIntegration: false,
  hasOrderOperationsIntegration: false,
  hasOrderChargeTypeIntegration: false,
};

const useOrderDefinitions = (): OrderDefinitions => {
  const [orderDefinitions, setOrderDefinitions] =
    useState<OrderDefinitions>(orderDefinitionsDefault);

  const fetchOrderDefinitions = useCallback(async () => {
    const response = await restApi.get<OrderDefinitions>('orders/definitions');
    if (response.ok && response.data) {
      setOrderDefinitions(response.data);
    }
  }, [setOrderDefinitions]);

  useEffect(() => {
    fetchOrderDefinitions();
  }, [fetchOrderDefinitions]);

  return orderDefinitions;
};

export default useOrderDefinitions;
